import React, { useContext, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, MenuItem, Stack, TextField, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { categories, list_repas } from "../conf";

export default function DelegueForm(props) {
    const { updateConnect } = useContext(Context);
    const [load, setLoad] = useState(false);
    const [genre, setGenre] = useState(props.delegue?.genre ?? 'Mr');
    const [nom, setNom] = useState(props.delegue?.nom ?? '');
    const [prenoms, setPrenoms] = useState(props.delegue?.prenoms ?? '');
    const [mail, setMail] = useState(props.delegue?.mail ?? '');
    const [tel, setTel] = useState(props.delegue?.tel ?? '');
    const [categorie, setCategorie] = useState(props.delegue?.categorie ?? '');
    const [repas, setRepas] = useState(props.delegue?.repas ?? list_repas.map(repas => ({ repas, count: 0 })));
    const [transport, setTransport] = useState(props.delegue?.transport ?? false);
    const [msg, setMsg] = useState();

    async function handleSubmit(event) {
        event.preventDefault();
        setLoad(true);
        setMsg('');
        fetch(API.concat(props.edit ? `/Delegue/by/${JSON.stringify({ _id: props.delegue?._id })}` : '/delegue'), {
            method: props.edit ? 'PATCH' : 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify({
                genre, nom, prenoms, mail, tel, categorie, repas, transport
            })
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    props.add(json);
                    props.close();
                    setLoad(false);
                } else {
                    const text = await response.text();
                    setMsg(text);
                    setLoad(false);
                }
            }
        });
    }

    return (
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit ? 'Modifier' : 'Créer'} un délégué</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <RadioGroup row sx={{minWidth:'280px'}}
                    defaultValue={genre}
                    name="radio-buttons-group"
                    onChange={(event)=> setGenre(event.target.value)}
                    >
                        <FormControlLabel value="Mr" control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Mr" componentsProps={{typography:{fontSize:15}}} />
                        <FormControlLabel value="Mme" control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Mme" componentsProps={{typography:{fontSize:15}}} />
                    </RadioGroup>
                    <TextField required fullWidth label="Nom" autoComplete="family-name" autoFocus
                        error={/(?:^\s+|\s+$)/.test(nom)} helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces"}
                        sx={{ minWidth: '200px' }} value={nom} onChange={(event) => setNom(event.target.value)} />
                    <TextField required fullWidth label="Prénoms" autoComplete="given-name"
                        error={/(?:^\s+|\s+$)/.test(prenoms)} helperText={/(?:^\s+|\s+$)/.test(prenoms) && "ne doit pas commencer/finir ou ne contenir que des espaces"}
                        sx={{ minWidth: '200px' }} value={prenoms} onChange={(event) => setPrenoms(event.target.value)} />
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Email" autoComplete="email"
                    sx={{ minWidth: '200px' }} value={mail} onChange={(event) => setMail(event.target.value)} />
                    <TextField fullWidth label="Téléphone" autoComplete="tel"
                    sx={{ minWidth: '200px' }} value={tel} onChange={(event) => setTel(event.target.value)} />
                    <TextField select required fullWidth value={categorie} onChange={e => setCategorie(e.target.value)} label="Catégorie">
                        {categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                    </TextField>
                </Stack>
                <Typography variant="h6" align="center" marginBottom='5px'>Repas</Typography>
                <Stack direction='row' rowGap={2} columnGap={2} alignItems='center' flexWrap='wrap'>
                    {repas.map(repas =>
                    <TextField label={repas.repas} key={repas.repas} type="number" slotProps={{ input: { min: 0 } }}
                        sx={{ minWidth: '150px' }} value={repas.count} 
                        onChange={(event) => setRepas(old=>{
                            const copy = [...old];
                            copy.find(r=>r.repas===repas.repas).count = event.target.value;
                            return copy;
                        })} />
                    )}
                </Stack>
                <Typography variant="h6" align="center" marginBottom='5px'>Transport</Typography>
                <RadioGroup row sx={{minWidth:'280px', justifyContent:'center'}}
                defaultValue={transport}
                name="radio-buttons-group"
                onChange={(event)=> setTransport(event.target.value)}
                >
                    <FormControlLabel value={true} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Oui" slotProps={{typography:{fontSize:15}}} />
                    <FormControlLabel value={false} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Non" slotProps={{typography:{fontSize:15}}} />
                </RadioGroup>
            </Stack>

            <Button variant="contained" type="submit" sx={{ marginTop: '20px', borderRadius: 0, paddingBlock: 1.5 }}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress /></Backdrop>
        </Box>
    );
}